import { InfoCircle } from '@/assets/icons'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/popover/Popover'

import { kMatterRoleDescriptions } from './types'

/** "Roles & Permissions" info popover — shown to collaborators so they know what they (and others) can do. */
export function RolesPermissionsPopover() {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          className="flex shrink-0 items-center gap-1 rounded bg-brand-neutral-100 px-2 py-0.5 text-xs font-medium text-brand-neutral-600 outline-none hover:bg-brand-neutral-200 focus-visible:ring-2 focus-visible:ring-brand-500"
        >
          Roles & Permissions
          <InfoCircle className="size-3.5" aria-hidden />
        </button>
      </PopoverTrigger>
      <PopoverContent width="md" align="end">
        <div className="flex flex-col gap-4">
          {kMatterRoleDescriptions.map((role) => (
            <div key={role.label}>
              <p className="text-sm font-medium text-brand-neutral-700">{role.label}</p>
              <p className="text-xs text-brand-neutral-600">{role.description}</p>
            </div>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  )
}
